import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import GenerateInvoice from "../Components/generateInvoice";
import UploadInvoice from "../Components/uploadInvoice";
import InvoiceList from "../Components/invoiceList";
import stockService from "../services/stock-service";
import moment from "moment";
const InvoiceSrn = () => {
  const [loading, setLoading] = useState(false);
  const [openTab, setOpenTab] = React.useState(1);
  const [totalMonths, setTotalMonths] = useState([]);
  const [parentsList, setParentList] = useState([]);
  const getParents = async () => {
    try {
      setLoading(true);
      setTotalMonths(moment.months());
      let resp = await stockService.getParent();
      if (resp) {
        setParentList(resp);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };
  const totalYears = () => {
    const years = [];
    const dateStart = moment().subtract(1, "y");
    const dateEnd = moment().add(1, "y");
    while (dateEnd.diff(dateStart, "years") >= 0) {
      years.push(dateStart.format("YYYY"));
      dateStart.add(1, "year");
    }
    return years;
  };
  useEffect(() => {
    getParents();
  }, []);
  return (
    <>
      <CipHeader />
      <div
        className={`inline-block customtop z-50 absolute ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00B2A9"
          height={50}
          width={50}
          timeout={300000}
        />
      </div>
      <div className="bg-white w-11/12 sm:w-1/2 mt-12 mx-auto mb-2">
        <div className="text-left pt-5 pr-5 pb-5 pl-7 shadow-subheader">
          <span className="text-darkclr font-semibold">INVOICING</span>
        </div>
        <ul
          className="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row"
          role="tablist"
        >
          <li className="-mb-px mr-2 last:mr-0 flex-auto text-center">
            <a
              className={
                "text-xs font-bold uppercase px-2 py-3 shadow-lg rounded block leading-normal " +
                (openTab === 1 ? "text-black bg-menu_active" : " bg-black")
              }
              onClick={(e) => {
                e.preventDefault();
                setOpenTab(1);
              }}
              data-toggle="tab"
              href="#link1"
              role="tablist"
            >
              UPLOAD
            </a>
          </li>
          <li className="-mb-px mr-2 last:mr-0 flex-auto text-center">
            <a
              className={
                "text-xs font-bold uppercase px-2 py-3 shadow-lg rounded block leading-normal " +
                (openTab === 2 ? "text-black bg-menu_active" : " bg-black")
              }
              onClick={async (e) => {
                e.preventDefault();
                setOpenTab(2);
              }}
              data-toggle="tab"
              href="#link2"
              role="tablist"
            >
              GENERATE
            </a>
          </li>
          <li className="-mb-px  last:mr-0 flex-auto text-center">
            <a
              className={
                "text-xs font-bold uppercase px-2 py-3 shadow-lg rounded block leading-normal " +
                (openTab === 3 ? "text-black bg-menu_active" : "bg-black")
              }
              onClick={(e) => {
                e.preventDefault();
                setOpenTab(3);
              }}
              data-toggle="tab"
              href="#link3"
              id="link3"
              role="tablist"
            >
              LIST
            </a>
          </li>
        </ul>
        <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
          <div className="py-5 flex-auto">
            <div className="tab-content tab-space">
              {openTab === 1 ? (
                <div id="link1">
                  <UploadInvoice
                    totalMonths={totalMonths}
                    parentsList={parentsList}
                    totalYears={totalYears}
                  />
                </div>
              ) : null}
              {openTab === 2 ? (
                <div id="link2">
                  <GenerateInvoice
                    totalMonths={totalMonths}
                    parentsList={parentsList}
                    totalYears={totalYears}
                  />
                </div>
              ) : null}
              {openTab === 3 ? (
                <div id="link3">
                  <InvoiceList
                    totalMonths={totalMonths}
                    parentsList={parentsList}
                    totalYears={totalYears}
                  />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(InvoiceSrn)
);
